import { useEffect, useState } from 'react'
import type { User } from '../types'
import { PROFILE_PHOTO_CHANGED, profilePhotoFor } from '../lib/profilePhotos'

export function Avatar({ user, size = 36 }: { user: User; size?: number }) {
  const [photo, setPhoto] = useState<string | null>(() => profilePhotoFor(user.id))

  useEffect(() => {
    setPhoto(profilePhotoFor(user.id))

    const refresh = (event: Event) => {
      const detail = (event as CustomEvent<{ userId?: string }>).detail
      if (!detail?.userId || detail.userId === user.id) setPhoto(profilePhotoFor(user.id))
    }

    window.addEventListener(PROFILE_PHOTO_CHANGED, refresh)
    window.addEventListener('storage', refresh)
    return () => {
      window.removeEventListener(PROFILE_PHOTO_CHANGED, refresh)
      window.removeEventListener('storage', refresh)
    }
  }, [user.id])

  return (
    <div
      className="flex shrink-0 items-center justify-center overflow-hidden rounded-full font-semibold text-white"
      style={{ width: size, height: size, background: user.color, fontSize: size * 0.38 }}
      aria-label={`${user.name} profile photo`}
    >
      {photo ? (
        <img src={photo} alt="" className="h-full w-full object-cover" />
      ) : (
        user.initials
      )}
    </div>
  )
}

export const roleLabels: Record<User['role'], string> = {
  participant: 'Participant',
  rep: 'Family / Rep',
  support_worker: 'Support Worker',
  allied_health: 'Allied Health',
  coordinator: 'Support Coordinator',
}

export const roleColors: Record<User['role'], string> = {
  participant: 'bg-brand-100 text-brand-700',
  rep: 'bg-teal-500/10 text-teal-700',
  support_worker: 'bg-amber-100 text-amber-800',
  allied_health: 'bg-blue-100 text-blue-700',
  coordinator: 'bg-emerald-100 text-emerald-700',
}

